export const isUrsa = themeMode => {
  return themeMode.startsWith("ursa");
};
export const isLight = themeMode => {
  return themeMode.endsWith("light");
};
//# sourceMappingURL=themeHelper.js.map